module.exports = __webpack_public_path__ + "img/11.54b53621.png";